import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { smoothScroll } from "../../../../utils/scroll";

const ValueStatement = ({ campaignDefaults }) => {
  return (
    <div id="value-statement-cobranded" className="value-statement background-section d-flex value-statement-cobranded">
      <div className="statement-text-left">
        <div className="headline-font banner-title">Earn up to 35,000 American
              Airlines AAdvantage<sup className="h6">&reg;</sup> miles with a
              Barclays Personal Loan
        <div className="text-muted smaller-headline banner-points">For every $1 borrowed, earn 1 American Airlines AAdvantage<sup className="h6">&reg;</sup> mile - up to 35,000 AAdvantage<sup className="h6">&reg;</sup> bonus miles.
        </div>
        </div>
        <p className="d-flex align-items-center h4 font-weight-light statement banner-points">
          <i className="material-icons text-barclays-primary" aria-hidden="true">check</i>Rates starting at {campaignDefaults.minApr}% APR
          <sup className="superscript">
            <Link to="#cobranded-page-apr-foot-note" scroll={smoothScroll}>1</Link>
          </sup>
        </p>
        <p className="d-flex align-items-center h4 font-weight-light statement banner-points">
          <i className="material-icons text-barclays-primary" aria-hidden="true">check</i>Absolutely NO fees
        </p>
        <p className="d-flex align-items-center h4 font-weight-light statement banner-points">
          <i className="material-icons text-barclays-primary check-icon" aria-hidden="true">check</i>Financial freedom
        </p>
      </div>
    </div>
  );
};

export default ValueStatement;
